/**
 * カーソルスタイル生成ユーティリティ
 * Drawing コンポーネントで使用するカスタムカーソルのSVG生成
 */

type CursorShape = 'circle' | 'triangle' | 'square'

/**
 * 円形のカーソルSVGを生成
 * @param size - カーソルサイズ
 * @returns SVG data URL
 */
function createCircleCursor(size: number): string {
    return `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}"><circle cx="${size / 2}" cy="${size / 2}" r="${
        size / 2 - 1
    }" fill="none" stroke="white" stroke-width="2" /></svg>') ${size / 2} ${size / 2}, auto`
}

/**
 * 三角形のカーソルSVGを生成
 * @param size - カーソルサイズ
 * @returns SVG data URL
 */
function createTriangleCursor(size: number): string {
    return `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}"><polygon points="1,${size - 1} ${
        size / 2
    },1 ${size - 1},${size - 1}" fill="none" stroke="white" stroke-width="2" /></svg>') ${size / 2} ${size / 2}, auto`
}

/**
 * 四角形のカーソルSVGを生成
 * @param size - カーソルサイズ
 * @returns SVG data URL
 */
function createSquareCursor(size: number): string {
    return `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}"><rect x="1" y="1" width="${
        size - 2
    }" height="${size - 2}" fill="none" stroke="white" stroke-width="2" /></svg>') ${size / 2} ${size / 2}, auto`
}

/**
 * カーソルスタイルを生成
 * @param shape - カーソル形状（circle, triangle, square）
 * @param size - カーソルサイズ
 * @returns CSS cursor プロパティ値
 */
export function cursorStyle(shape: CursorShape, size: number): string {
    switch (shape) {
        case 'circle':
            return createCircleCursor(size)
        case 'triangle':
            return createTriangleCursor(size)
        case 'square':
            return createSquareCursor(size)
        default:
            return 'default'
    }
}
